import { render } from "./hamburger.vue?vue&type=template&id=72c03442"
import script from "./hamburger.vue?vue&type=script&lang=js"
export * from "./hamburger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__